import React from 'react';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-thumb': {
    color: theme.palette.primary.main, // Set the color of the thumb (knob)
  },
  '& .Mui-disabled .MuiSwitch-thumb': {
    color: theme.palette.grey[500], // Set the color of the thumb (knob) when disabled
  },
}));

const CustomTypography = styled(Typography)(({ theme, disabled }) => ({
  color: disabled ? theme.palette.grey[500] : 'inherit',
}));

export const SwitchWithLabels = ({ leftLabel, rightLabel, disabled, ...props }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <CustomTypography variant="caption" disabled={disabled}>{leftLabel}</CustomTypography>
      <CustomSwitch {...props} disabled={disabled} />
      <CustomTypography variant="caption" disabled={disabled}>{rightLabel}</CustomTypography>
    </div>
  );
};

const GreenRedSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: 'white',
      '& + .MuiSwitch-track': {
        backgroundColor: 'green',
      },
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'red',
  },
}));

export const GreenRedSwitchWithLabels = ({ leftLabel, rightLabel, disabled, ...props }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <CustomTypography variant="caption" disabled={disabled}>{leftLabel}</CustomTypography>
      <GreenRedSwitch {...props} disabled={disabled} />
      <CustomTypography variant="caption" disabled={disabled}>{rightLabel}</CustomTypography>
    </div>
  );
};